<template>
  <select
    v-model="chosenAId"
    class="mg-x-10 pd-x-5 missing-select bg-white bd-b font-weight-light d-inline-block wd-auto pd-b-5-f"
    @change="$emit('change', { qId: qId, gId: gId, aId: chosenAId })"
  >
    <option :value="null">...</option>
    <option v-for="(a, i) in answers" :value="a.aId" :key="i + '_' + a.aId">{{
      a.a
    }}</option>
  </select>
</template>

<script>
export default {
  props: {
    qId: {
      type: Number,
      default: () => 0
    },
    gId: {
      type: Number,
      default: () => 0
    },
    answers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chosenAId: null
    };
  },
  mounted() {
    let fld = this.answers.filter(x => x.isFilled);
    if (fld.length) {
      this.chosenAId = fld[0]["aId"];
    }
    //console.log();
  }
};
</script>

<style></style>
